"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openHotelPage = void 0;
var _reactRouter = require("react-router");
var _book = require("../routes/book");
var generateHotelUrl = function generateHotelUrl(_ref) {
  var hotelID = _ref.hotelID,
    currency = _ref.currency;
  var path = (0, _reactRouter.generatePath)(_book.book.hotel, {
    hotelID: hotelID
  });
  return currency ? "".concat(path, "?currency=").concat(currency) : path;
};
var openHotelPage = exports.openHotelPage = function openHotelPage(_ref2) {
  var hotelID = _ref2.hotelID,
    currency = _ref2.currency;
  return global.open(generateHotelUrl({
    hotelID: hotelID,
    currency: currency
  }), '_blank');
};